import * as PIXI from 'pixi.js';
import { addToGameLoop, removeFromGameLoop } from '../../lib/gameLoop';
import { construct } from './commonInitializer';
import { commonPropertySetters } from '../../lib/commonPropertySetters';

export class Container extends PIXI.Container {
  constructor(options) {
    super();
    this.roundPixels = true;
    construct.call(this, options);
  }

  applyStyles(styles = {}) {
    if (Array.isArray(styles)) styles = styles.reduce((r, c) => Object.assign(r, c), {});
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const prop in styles) {
      const value = styles[prop];
      if (commonPropertySetters[prop]) commonPropertySetters[prop].call(this, value);
    }
  }

  setCashAsBitmap(value) {
    if (!process.env.BUILD_TYPE.includes('testView')) {
      if (!value) {
        this.cacheAsBitmap = value;
        removeFromGameLoop(this._cashAsBitmapLoop, this);
      } else {
        this._canSetCashAsBitmap = false;
        addToGameLoop(this._cashAsBitmapLoop, this);
      }
    }
  }

  _cashAsBitmapLoop() {
    if (this._canSetCashAsBitmap) {
      this.cacheAsBitmap = true;
      removeFromGameLoop(this._cashAsBitmapLoop, this);
    } else if (this.worldVisible && this.width && this.height) {
      this._canSetCashAsBitmap = true;
    }
  }

  hide() {
    this.visible = false;
  }

  show() {
    this.visible = true;
  }
  // set interactive(val){
  //     this._aaaaaa = val
  // }
  // get interactive(){
  //     return !!this._aaaaaa;
  // }
}
